import { Auth } from 'aws-amplify';

import LogoutIcon from '@mui/icons-material/Logout';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const LogoutSection = () => {
  const theme = useTheme();

  const signOut = () => {
    Auth.signOut()
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
  };

  return (
    <Box marginLeft={theme.spacing(2)}>
      <Button onClick={() => signOut()} sx={{ display: { xs: 'none', sm: 'block' }, textTransform: 'none' }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LogoutIcon sx={{ color: 'primary.main' }} />
          <Typography variant = 'h3'sx={{ color: 'primary.main' }}><b>Logout</b></Typography>
        </Stack>
      </Button>

    </Box>
  );
};

export default LogoutSection;
